<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import moment from 'moment';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default {
   page: {
      title: "Earnings Report",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: { Layout, PageHeader },
   data() {
      const current_date = moment().format("YYYY-MM-DD");
      return {
         title: "Earnings Report",
         items: [
            {
               text: "Earnings Report",
               active: true,
            },
         ],

         earnings: [],
         all_earnings: [],
         totalAmount: "",
         earningTotal: "",

         pagination: {},

         type: "",
         keyword: "",
         listing_length: 10,
         status: '',
         token: "",
         from_date: current_date,
         to_date: current_date,
         errors: {},
         active_page_url: null,
         report_type: 1,
         consultation_type: '',
      };
   },
   mounted() {
      this.clearLocalStorage();

   },

   created() {
      this.fetchEarnings();

   },

   methods: {

      clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
      getTotalAmount() {
         let totalAmount = 0;
         for (let i = 0; i < this.earnings.length; i++) {
            if (this.report_type == 1) {
               totalAmount += parseFloat(this.earnings[i].total_amount);
            } else {
               totalAmount += parseFloat(this.earnings[i].total);
            }
         }
         this.totalAmount = totalAmount;

      },
      clearForm() {
         this.errors = {};  
      },
      fetchEarnings(page_url = null) {

         this.getToken();
         let url = "api/admin/earnings_report?&limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&type=" + this.type + "&report_type=" + this.report_type;

         page_url = page_url || url;

         if (localStorage.back_url) {
            page_url = localStorage.back_url;
            localStorage.removeItem('back_url');
         }

         this.active_page_url = page_url;
         this.loading = true;

         this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               // console.log(responseData);
               this.earnings = responseData.earnings.data;
               this.all_earnings = responseData.all_earnings;
               this.earningTotal = responseData.total_amount;

               this.pagination = responseData.earnings.links;
               this.from = responseData.earnings.from;
                 this.to = responseData.earnings.to;
               this.total = responseData.earnings.total;
               this.getTotalAmount();
               this.clearForm();


            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if (typeof error.response.data.message === 'object') {
                        this.errors = error.response.data.message;
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }

                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
      },

      downloadEarningsPdf() {

         let url = "api/admin/earnings_report_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + this.type + "&type=" + this.type + "&report_type=" + this.report_type;
         this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" 
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/pdf" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "Earnings_report.pdf"; 
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                  console.error("Error downloading PDF file:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                     const text = event.target.result;
                     const errorData = JSON.parse(text);
                     const errorMessage = errorData.message;
                     if(errorMessage){
                        this.errors = errorMessage;
                     }else{
                     this.$swal("", "Failed to download PDF file", "error");
                     }
                  };
                  reader.readAsText(error.response.data);
               })

      },
      downloadEarningsPdfFromClient() {
         if (!this.all_earnings.length) {
            this.$swal("", "No data available to download", "info");
            return;
         }

         const doc = new jsPDF();
         doc.text("Earnings Report", 14, 15);
         if(this.report_type == 1){
            const headers = [
               ["#", "Patient", "Contact", "Doctor", "Type", "Booking Info", "Amount", "Created At"]
            ];

            const rows = this.all_earnings.map((earning, index) => {
            const patientName = earning.patient_name;
            const contact = `${earning.country_code || ""} ${earning.mobile || ""}\n${earning.email || ""}`;
            const doctor = `${earning.prefix || ""} ${earning.doctor_name}`;
            const type =
               earning.consultation_type === 1
               ? "Video"
               : earning.consultation_type === 2
               ? "Home"
               : "Clinic";

            const bookingInfo = `${this.$options.filters.formatDate(earning.booking_date)}\n${this.$options.filters.formatTime(earning.consultation_start)} - ${this.$options.filters.formatTime(earning.consultation_end)}\n${earning.status === 3 ? "Cancelled\n" : ""}#${earning.id}`;

            const amount = `Rs. ${earning.total_amount}`;
            const createdAt = this.$options.filters.formatDateTime(earning.payment_created_at);

            return [
               index + 1,
               patientName,
               contact,
               doctor,
               type,
               bookingInfo,
               amount,
               createdAt
            ];
         });

         autoTable(doc, {
            startY: 20,
            head: headers,
            body: rows,
            styles: { fontSize: 7 },
            headStyles: { fillColor: [41, 128, 185] },
            columnStyles: {
               0: { cellWidth: 10 },  // #
               1: { cellWidth: 30 },  // Patient
               2: { cellWidth: 40 },  // Contact
               3: { cellWidth: 20 },  // Doctor
               4: { cellWidth: 10 },  // Type
               5: { cellWidth: 30 },  // Booking Info
               6: { cellWidth: 20 },  // Amount
               7: { cellWidth: 30 },  // Created At
            }
         });

         doc.save("Earnings_Report.pdf");
      }else{
          const headers = [
               ["#", "Order ID", "Patient", "Contact", "Type", "Delivery Date & Time", "Delivery Charge", "Amount", "Discount", "Total", "Created On"]
            ];

         const rows = this.earnings.map((earning, index) => {
            const type =
               earning.delivery_type === 1
                  ? "Regular"
                  : earning.delivery_type === 2
                  ? "Express"
                  : "-";

            return [
               index + 1,
               `#${earning.id}`,
               earning.patient_name,
               `${earning.country_code || ""} ${earning.mobile || ""}\n${earning.email || ""}`,
               type,
               `${this.$options.filters.formatDate(earning.delivery_date)}\n${this.$options.filters.formatTime(earning.delivery_time)}`,
               `Rs. ${earning.delivery_charge}`,
               `Rs. ${earning.price}`,
               `Rs. ${earning.discount}`,
               `Rs. ${earning.total}`,
               this.$options.filters.formatDateTime(earning.created_at),
            ];
         });

         autoTable(doc, {
            startY: 20,
            head: headers,
            body: rows,
            styles: { fontSize: 7 },
            headStyles: { fillColor: [41, 128, 185] },
            columnStyles: {
               0: { cellWidth: 10 },   // #
               1: { cellWidth: 10 },   // Order ID
               2: { cellWidth: 20 },   // Patient
               3: { cellWidth: 20 },   // Contact
               4: { cellWidth: 10 },   // Type
               5: { cellWidth: 25 },   // Delivery Date & Time
               6: { cellWidth: 10 },   // Delivery Charge
               7: { cellWidth: 20 },   // Amount
               8: { cellWidth: 10 },   // Discount
               9: { cellWidth: 20 },   // Total
               10: { cellWidth: 35 },  // Created On
            }
         });

         doc.save("Earnings_Report.pdf");

         }
      },


      downloadEarningsExcel() {
         let url = "api/admin/earnings_excel_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + this.type + "&type=" + this.type + "&report_type=" + this.report_type;
         this.getToken();
         this.loading = true;
         this.$axios
            .get(url, {
                  headers: { Authorization: "Bearer " + this.token },
                  responseType: "blob" // Specify blob response type
            })
            .then((res) => {
                  const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                  const url = window.URL.createObjectURL(blob);
                  const link = document.createElement("a");
                  link.href = url;
                  link.download = "Earnings_report.xlsx";
                  link.click();
                  window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
               console.error("Error downloading PDF file:", error);
               const reader = new FileReader();
               reader.onload = (event) => {
                  const text = event.target.result;
                  const errorData = JSON.parse(text);
                  const errorMessage = errorData.message;
                  if(errorMessage){
                     this.errors = errorMessage;
                  }else{
                  this.$swal("", "Failed to download PDF file", "error");
                  }
               };
               reader.readAsText(error.response.data);
            })
      },


      getToken() {
         if (localStorage.getItem('medicino_admin')) {
            var medicino_admin = JSON.parse(localStorage.getItem('medicino_admin'));
            if (medicino_admin.token) {
               this.token = medicino_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },


   }
}
</script>

<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">

            <div class="card">
               <div class="card-body">
                  <!----- filters area starts---->
                  <div class="row mb-3">
                     <div class="form-group col-lg-3">
                        <label>From Date <span class="text-danger">*</span></label>
                        <b-form-input type="date" v-model="from_date" class="form-control"
                           v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }"></b-form-input>
                        <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                     <div class="form-group col-lg-3">
                        <label>To Date <span class="text-danger">*</span></label>
                        <b-form-input type="date" v-model="to_date" class="form-control"
                           v-bind:class="{ 'is-invalid': Boolean(errors.to_date) }"></b-form-input>
                        <div v-for="(val, index) in errors.to_date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>

                     <div class="form-group col-lg-3">
                        <label>Report Type</label>
                        <select class="form-control" v-model="report_type" >
                           <option value="1">Consultation</option>
                           <option value="2">Pharmacy</option>
                        </select>
                     </div>
                     <div class="form-group col-lg-3" v-if="report_type == 1">
                        <label>Consultation Type</label>
                        <select class="form-control" v-model="type" >
                           <option value="">All</option>
                           <option value="1">Video</option>
                           <option value="2">Home</option>
                           <option value="3">Clinic</option>
                        </select>
                     </div>
                     <div class="form-group col-lg-3" v-if="report_type == 2">
                        <label>Delivery Type</label>
                        <select class="form-control" v-model="type" >
                           <option value="">All</option>
                           <option value="1">Express</option>
                           <option value="2">Regular</option>
                        </select>
                     </div>
                  </div>
                  <!----- filters area ends---->

                  <div class="row">
                     <div class="col-12">
                        <button class="btn btn-primary me-2" type="button" @click="fetchEarnings()">View</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadEarningsPdfFromClient()">Download PDF</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadEarningsExcel()">Download Excel</button>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row mb-3">
               <div class="col-lg-3">
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h5 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 px-1 py-1 mb-1"
                        v-if="report_type == 1"> Total Amount <br><br>Rs. {{ earningTotal }}
                     </h5>
                     <h5 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 px-1 py-1 mb-1"
                        v-if="report_type == 2"> Total Amount <br><br>Rs. {{ earningTotal }}
                     </h5>
                  </b-card>
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length">
                           <label>Show
                              <select class="form-control" v-model="listing_length" @change="fetchEarnings">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"
                                 @keyup="fetchEarnings()" />
                           </label>
                        </div>

                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0" v-if="report_type == 1">
                        <thead class="table-light">
                           <tr>
                              <th width="8%">Sl No</th>

                              <th width="15%">Patient</th>
                              <th width="15%">Contact</th>
                              <th width="15%">Doctor</th>
                              <th width="5%">Type</th>
                              <th width="20%">Booking Date & Slot & Booking ID</th>
                              <th width="20%">Amount</th>
                              <th width="15%">Created On</th>
                              <th width="20%">Options</th>
                           </tr>

                        </thead>
                        <tbody vif="earnings.length >0">
                           <tr v-for="(earning, index) in earnings" :key="earning.id">
                              <td>{{index + from}}</td>
                              <td>{{ earning.patient_name }}</td>
                              <td>
                                 {{ earning.country_code }} {{ earning.mobile }}<br>
                                 {{ earning.email }}<br>
                              </td>
                              <td>{{ earning.prefix }} {{ earning.doctor_name }}</td>
                              <td v-if="earning.consultation_type === 1">Video</td>
                              <td v-if="earning.consultation_type === 2">Home</td>
                              <td v-if="earning.consultation_type === 3">Clinic</td>

                              <td>{{ earning.booking_date | formatDate }}<br>{{ earning.consultation_start | formatTime
                                 }} -
                                 {{ earning.consultation_end | formatTime }}<br><span v-if="earning.status==3">Cancelled <br></span>#{{ earning.id}}</td>
                              <td>Rs. {{ earning.total_amount }}</td>
                              <td>{{ earning.payment_created_at | formatDateTime }}</td>

                              <td>
                                 <router-link :to="{ name: 'consultations.details', params: { id: earning.id } }"
                                    class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>

                                 <!-- <button class="btn btn-warning me-2 mb-2 btn-sm" type="button">Reschedule</button>
                                 <button v-b-modal.cancel-modal class="btn btn-danger me-2 mb-2 btn-sm" type="button">Cancel</button> -->
                              </td>
                           </tr>

                        </tbody>
                     </table>
                     <table class="table table-bordered mb-0" v-if="report_type == 2">
                        <thead class="table-light">
                           <tr>
                              <th width="6%">Order ID</th>
                              <th width="11%">Patient</th>
                              <th width="11%">Contact</th>
                              <th width="5%">Type</th>
                              <th width="15%">Delivery Date & Time</th>
                              <th width="8%">Delivery Charge</th>
                              <th width="8%">Amount</th>
                              <th width="8%">Discount</th>
                              <th width="8%">Total</th>
                              <th width="10%">Created On</th>
                              <th width="10%">Options</th>
                           </tr>

                        </thead>
                        <tbody v-if="Boolean(earnings.length)">
                           <tr v-for="earning in earnings" :key="earning.id">
                              <td>#{{ earning.id }}</td>
                              <td>{{ earning.patient_name }}</td>
                              <td>
                                 {{ earning.country_code }} {{ earning.mobile }}<br>
                                 {{ earning.email }}<br>
                              </td>
                              <td v-if="earning.delivery_type === 1">Regular</td>
                              <td v-if="earning.delivery_type === 2">Express</td>

                              <td>{{ earning.delivery_date | formatDate }}<br>{{ earning.delivery_time | formatTime }}
                              </td>
                              <td>Rs.{{ earning.delivery_charge }}</td>
                              <td>Rs.{{ earning.price }}</td>
                              <td>Rs.{{ earning.discount }}</td>
                              <td>Rs.{{ earning.total }}</td>
                              <td>{{ earning.created_at | formatDateTime }}</td>

                              <td>
                                 <router-link :to="{ name: 'pharmacy.orders.details', params: { id: earning.id } }"
                                    class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>

                                 <!-- <button class="btn btn-warning me-2 mb-2 btn-sm" type="button">Reschedule</button>
                                 <button v-b-modal.cancel-modal class="btn btn-danger me-2 mb-2 btn-sm" type="button">Cancel</button> -->
                              </td>
                           </tr>

                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No earnings found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->
                  <caption v-if="Boolean(earnings.length)" class="float-start mt-4 d-block d-lg-inline">Showing
                     {{ this.from }} to {{ this.to }} of {{ this.total }} entries</caption>
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item " v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
                        v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link"
                           @click.prevent="fetchEarnings(page.url + '&limit=' + listing_length + '&from_date=' + from_date + '&to_date=' + to_date + '&keyword=' + keyword + '&type=' + type + '&report_type=' + report_type)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length - 1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{ page.label }}</span>
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
